var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.449 7.755a2.73 2.73 0 0 1-3.237 2.683c-1.232-.226-2.223-1.56-2.223-2.815v-.827c0-1.255.983-2.597 2.223-2.815a2.73 2.73 0 0 1 3.236 2.683z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.719 19.688a8.969 8.969 0 1 0 0-17.938 8.969 8.969 0 0 0 0 17.938"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M4.604 17.278c.999-2.246 3.362-3.83 6.115-3.83s5.116 1.584 6.114 3.83"
})));
export default SvgUsers;